<template>
  <transition name="modal" appear>
    <div class="p-modal is-open" :class="`p-modal--${ option }`">
      <div class="p-modal__wrapper">
        <div class="p-modal__bg" @click="$emit('close')" />
        <div class="p-modal__body">
          <div
            :class="{ wide__content: wide }"
            class="p-modal__content is-open"
            :style="contentStyled"
          >
            <slot />
          </div>
          <button
            v-if="option === 'photo'"
            class="p-modal__prev"
            @click="$emit('prev')"
          >
            <Icon name="arrowLeft" />
          </button>
          <button
            v-if="option === 'photo'"
            class="p-modal__next"
            @click="$emit('next')"
          >
            <Icon name="arrowRight" />
          </button>
        </div>
        <button
          v-if="option === 'photo'"
          class="p-modal__close"
          @click="$emit('close')"
        >
          <Icon name="close" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import Icon from './Icon.vue'

export default {
  name: 'Modal',
  components: {
    Icon
  },
  props: {
    option: {
      type: String
    },
    wide: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
  },
  emits: ['close', 'prev', 'next'],
  computed: {
    contentStyled() {
      const styles = {}
      if (this.width) styles['max-width'] = this.width
      return styles
    },
  }
}
</script>

<style lang="scss" scoped>
.wide__content {
  width: 1180px
}
</style>